import { render, staticRenderFns } from "./simple-product.vue?vue&type=template&id=6d48c45b&scoped=true&"
import script from "./simple-product.vue?vue&type=script&lang=js&"
export * from "./simple-product.vue?vue&type=script&lang=js&"
import style0 from "./simple-product.vue?vue&type=style&index=0&id=6d48c45b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d48c45b",
  null
  
)

export default component.exports